import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { API_URL } from "../constants";

export const useCheckAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        //todo: update with common API, not river-map
        const response = await axios.get(`${API_URL}/river-map`, {
          withCredentials: true,
        });
        const { auth } = response.data;

        if (!auth) {
          navigate("/");
        }
      } catch (e: any) {
        if (e?.status === 401 || e?.response?.status === 401) {
          navigate("/");
        }
      }
    }

    fetchData();
  });
};
